// src/pages/OAuthCallback.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function OAuthCallback() {
    const navigate = useNavigate();

    useEffect(() => {
        // If tokens are already set, don't re-process
        const existingAccessToken = localStorage.getItem('access_token');
        const existingRefreshToken = localStorage.getItem('refresh_token');
        if (existingAccessToken && existingRefreshToken) {
            // Already processed—redirect immediately
            navigate('/', { replace: true });
            return;
        }

        // Parse the query parameters for tokens
        const params = new URLSearchParams(window.location.search);
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');

        console.log('Current URL:', window.location.href);
        console.log('accessToken:', accessToken);
        console.log('refreshToken:', refreshToken);

        if (accessToken && refreshToken) {
            // Save the tokens (or update your auth context as needed)
            localStorage.setItem('access_token', accessToken);
            localStorage.setItem('refresh_token', refreshToken);

            // Redirect to the homepage (or wherever)
            navigate('/', { replace: true });
        } else {
            // If tokens are missing, redirect back to login
            navigate('/login', { replace: true });
        }
    }, [navigate]);

    return (
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <p>Completing login...</p>
        </div>
    );
}

export default OAuthCallback;
